import React, { ReactElement, useContext, ChangeEvent } from 'react';
import styled from 'styled-components/macro';
import { FormsContext } from 'pages/Forms/context/FormsContext';
import Prompt from '../Prompt';
import QuestionHeader from '../QuestionHeader';
import RequiredSelector from './RequiredSelector';
import { IFromDraftCommonProps } from '../Question';
import { FormQuestionType } from '@televet/shared-types';
import { TextInput } from '@televet/kibble-ui/build/components/TextInput';

interface IRating extends IFromDraftCommonProps {
  minValue: number;
  maxValue: number;
}

const Rating = ({ index, prompt, minValue, maxValue, isRequired, lastIndex }: IRating): ReactElement => {
  const { dispatch } = useContext(FormsContext);

  const handleMinValueChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const newValue = event.target.value;
    dispatch({ type: 'CHANGE_MIN_VALUE_AT_INDEX', payload: { questionIndex: index, minValue: newValue } });
  };

  const handleMaxValueChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const newValue = event.target.value;
    dispatch({ type: 'CHANGE_MAX_VALUE_AT_INDEX', payload: { questionIndex: index, maxValue: newValue } });
  };

  return (
    <>
      <QuestionHeader index={index} questionType={FormQuestionType.RatingInput} lastIndex={lastIndex} />
      <Prompt index={index} prompt={prompt} />
      <RatingDiv>
        <RatingContainer>
          <InputLabel>Min Rating:</InputLabel>
          <TextInput
            name="min"
            label="Min Rating"
            placeholder="Min Rating"
            type="number"
            value={minValue || 1}
            onChange={handleMinValueChange}
          />
        </RatingContainer>
        <RatingContainer>
          <InputLabel>Max Rating:</InputLabel>
          <TextInput
            name="max"
            label="Max Rating"
            placeholder="Max Rating"
            type="number"
            value={maxValue}
            onChange={handleMaxValueChange}
          />
        </RatingContainer>
      </RatingDiv>
      <RequiredSelector index={index} isRequired={isRequired} />
    </>
  );
};

export default Rating;

const RatingDiv = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const RatingContainer = styled.div`
  margin-right: 16px;
`;

const InputLabel = styled.h4`
  color: #73747d;
  font-size: 14px;
  padding: 8px 0 8px 5px;
`;
